// extracted by mini-css-extract-plugin
module.exports = {"avatarName":"AvatarName_avatarName__JOrui","image":"AvatarName_image__33dnT","name":"AvatarName_name__2WYm4"};